import { QueryOptionsType, MainIcons } from "@framework/types";
import http from "@framework/utils/http";
import { API_ENDPOINTS } from "@framework/utils/api-endpoints";
import { useQuery } from "react-query";
export const fetchMainIcons = async ({
  queryKey
}: any) => {
  const [_key, _params] = queryKey;
  const {
    data
  } = await http.get(API_ENDPOINTS.MAIN_ICONS);
  return data as MainIcons[];
};
export const useMainIconsQuery = (options: QueryOptionsType) => {
  return useQuery<MainIcons[], Error>([API_ENDPOINTS.MAIN_ICONS, options], fetchMainIcons, {
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  });
};